import imageUrl from "../../../../../docs/assets/logo.png";
import * as React from 'react';
export default {
  imageUrl,
  React
};